<template>
  <div class="route">
    <svg :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g ref="mobile">
        <path d="M502 403L296 525" />
        <path d="M297 523.5L187.5 587L398.5 709L187.5 831L409.5 964L233.5 1069L301 1103" />
        <path d="M300 1099.5L416.5 1167L192.5 1296.5L398.5 1415.5L95 1606L357 1759L74.5 1928.5L177 1989.5" />
        <path d="M182 1989.5L236.5 2024.5L109.5 2102.5L383 2267L171.5 2387.5L364.5 2495L152 2627L375 2759.5L261 2830.5" />
        <path d="M261 2834.5L165 2890L401 3027.5L61.5 3229.5L411.5 3433L136.5 3596.5" />
        <path d="M135.5 3604L81 3634L304 3761L66.5 3903.5L405 4107L199 4234L419 4355.5L271.5 4451.5" />
        <path d="M261 4457L160 4521.5L411.5 4663L46 4867.5L276.5 5009L46 5147.5L177 5221.5" />
        <path d="M195 5230.5L383 5342L173 5463.5L394.5 5592L57.5 5787.5L394.5 5975.5L297.5 6048" />
      </g>

      <g ref="desktop">
        <path d="M715 0L1367 377.5L1100 534.53" stroke-width="5"/>
        <path d="M1100 534.53L819.5 699.5L1292 971.5L460 1451.5L589.5 1526.62" stroke-width="3"/>
        <path d="M589.5 1526.62L822 1661.5L551 1824L1275 2237L670 2591.5L824.75 2680.25" stroke-width="3"/>
        <path d="M824.75 2680.25L979.5 2769L478 3061.5L779.5 3235L364 3471L740.5 3686L616 3759.25" stroke-width="3"/>
        <path d="M616 3759.25L491.5 3832.5L1068.5 4162L542.5 4470.5L1068.5 4780L854 4905.75" stroke-width="3"/>
        <path d="M854 4905.75L639.5 5031.5L1030.5 5259.5L388 5631.5L781.5 5861L634 5947.25" stroke-width="3"/>
        <path d="M634 5947.25L489 6029L735.5 6172L479.5 6319L1078.5 6664L657 6906.5L813.5 6996" stroke-width="3"/>
        <path d="M814.5 6997L974 7089.5L240 7514L926.5 7913.5L521.5 8147.25" stroke-width="3"/>
      </g>
      <g ref="pathset"></g>
    </svg>
    <div class="car" ref="car">
      <img src="@/assets/images/car.png">
    </div>
  </div>
</template>



<script>
  import anime from 'animejs'
  import { viewNames } from '@/ulils/responsive.breakpoints'

  export default {
    data () {
      return { paths: [], pathSet: null }
    },
    watch: {
      view () {
        this.update()
        this.drive()
      },
      step () {
        this.update()
        this.drive()
      }
    },
    mounted () {
      this.update()
      this.drive()
    },
    computed: {
      view () {
        return this.$store.getters.view
      },
      viewBox () {
        return {
          [viewNames.FULL]: `0 0 1440 9182`,
          [viewNames.COMPACT]: `0 0 475 6400`
        }[this.view]
      },
      step () {
        const current = this.$store.state.current
        return current === null ? 0 : current + 1
      },
    },
    methods: {
      update () {
        const paths = [].map.call(this.$refs[this.view].querySelectorAll('path'), (p) => p)
        const path = paths[Number(this.step)]
        const lines = path.getAttribute('d').replace('M', '').split('L')
        const parts = lines.map((line, idx) => {
          const next = lines[idx + 1]
          if (!next) return
          return `M${line}L${next}`
        }).slice(0, -1)

        const elements = parts.map((path) => {
          const el = document.createElementNS('http://www.w3.org/2000/svg', 'path')
          el.setAttribute('d', path)
          this.$refs.pathset.appendChild(el)
          return el
        })

        const speed = this.$store.state.carSpeed

        const durations = elements.map((element) => {
          const length = element.getTotalLength()
          const slowDownOnShortParts = speed < 1.5 ? (length < 400 ? 250 : 0) : 0
          return length/speed + slowDownOnShortParts + (!this.step ? 1000 : 0)
        })

        this.$store.commit('durations', durations)

        this.pathSet = elements
      },

      drive () {
        const tl = anime.timeline()

        let prev = 99999
        let dir

        const durations = this.$store.state.durations
        this.pathSet.forEach((element, idx) => {
          const path = anime.path(element)
          const lastPath = idx === this.pathSet.length -1
          const easing = idx === 0 ? 'easeInSine' : lastPath ? 'easeOutSine' : 'linear' // idx === 0 ? 'easeInOutSine' : idx === (durations.length - 1) ? 'easeOutSine' : 'easeInOutSine'
          const duration = durations[idx]

          tl.add({
            targets: this.$refs.car,
            easing,
            duration,
            translateX: path('x'),
            translateY: path('y'),
            update: (e) => {
              const prop = e.animations.find(({ property }) => (property === 'translateX'))
              const value = Number(prop.currentValue.split('px')[0])
              let newDir

              if (value < prev) newDir = 'left'
              if (value > prev) newDir = 'right'

              if (value === prev) return

              if (dir !== newDir && dir !== undefined) {
                const img = this.$refs.car.children[0]
                img.className = newDir
              }

              dir = newDir
              prev = value
            }
          })
        })
      },
    }
  }
</script>

<style lang="scss">
  .route {
    position: relative;
  }

  .car {
    position: absolute;
    left: 0;
    top: 0;

    img {
      display: block;
      width: 1em;
      height: 1em;
      margin-left: -0.5em;
      margin-top: -0.5em;

      &.left {
        transform: scale(1, 1)
      }
      &.right {
        transform: scale(-1, 1)
      }
      @include mq(desktop) {
        font-size: 98px;
      }
      @include mq(scale) {
        font-size: 24.5rem;
      }
      @include less(tablet) {
        font-size: 60px;
      }
    }
  }
</style>
